import React, { type Ref } from 'react';

import Spinner from '../Spinner/Spinner';

import styles from './InfiniteScrollLoader.module.scss';

const InfiniteScrollLoader = ({ ref }: { ref?: Ref<HTMLDivElement> }) => {
  return (
    <div className={styles.infiniteScrollLoader} ref={ref}>
      <Spinner />
    </div>
  );
};

export default InfiniteScrollLoader;
